import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
const {INPUT, DATE ,DATE_ON ,DATE_PRE,TEXT_AREA,DATE_DISABLE_NO_DAY } = FIELD_TYPE;
const css = { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 };
const dataFields: DataFormField[] = [

  {
    type: DATE_DISABLE_NO_DAY,
    label: "Ngày nghỉ việc",
    name: "ngayNghiViec",
    disable: false,
    rules: [{required: true, message: "Chưa nhập ngày nghỉ việc "}],
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:10, md: 8, lg: 8, xl: 8},
  },
  {
    type: TEXT_AREA,
    label: "Lý do nghỉ việc",
    css:css,
    wrapperCol: { xs: 24,sm:14, md: 16, lg: 16, xl: 16 },
    labelCol: { xs: 24,sm:10, md: 8, lg: 8, xl: 8},
    name: "lyDoNghiViec",
    disable: false,
  },

];
export {dataFields};
